<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 16 16" fill="none">
    <path d="M7.50851 1.51163C7.74069 1.32223 8.08333 1.33599 8.29976 1.55243L9.89998 3.15264H12.0197L12.0806 3.15572C12.3785 3.18616 12.6109 3.43783 12.6109 3.74377V5.86354L14.2111 7.46376C14.4419 7.69461 14.4419 8.0688 14.2111 8.29965L12.6109 9.89987V12.0196C12.6109 12.3461 12.3462 12.6108 12.0197 12.6108H9.89998L8.29976 14.211C8.06891 14.4418 7.69472 14.4418 7.46386 14.211L5.86365 12.6108H3.74388C3.41741 12.6108 3.15275 12.3461 3.15275 12.0196V9.89987L1.55253 8.29965C1.32168 8.0688 1.32168 7.69461 1.55253 7.46376L3.15275 5.86354V3.74377L3.15583 3.68297C3.18627 3.38506 3.43794 3.15264 3.74388 3.15264H5.86365L7.46386 1.55243L7.50851 1.51163Z" 
    fill="#1F69FF"/>
    <path d="M9.69831 6.06731C9.43086 5.88023 9.06268 5.94538 8.87549 6.21279L7.18445 8.62812L6.49788 8.02775C6.25221 7.8128 5.87852 7.83757 5.66352 8.08317C5.44856 8.32883 5.47334 8.70253 5.71893 8.91753L6.9012 9.95201C7.02747 10.0625 7.19491 10.1137 7.36148 10.0936C7.52814 10.0734 7.67854 9.98333 7.77482 9.84579L9.84378 6.89013C10.0309 6.62268 9.96571 6.2545 9.69831 6.06731Z" 
    fill="url(#paint0_linear_14326_2123)" />
    <defs>
      <linearGradient id="paint0_linear_14326_2123" x1="7.89099" y1="-3.75853" x2="7.89099" y2="15.5081" gradientUnits="userSpaceOnUse">
        <stop offset="0.239531" stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0.8"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'VerifiedBadgeIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    }
  }
}
</script>